<template>
  <button v-bind="$attrs" :class="tabClasses" :disabled="disabled" :type="type">
    <IconBase
      v-if="icon && icon !== 'transparent'"
      :icon="icon"
      :tone="iconTone"
      :size="size"
    />

    <div v-if="hasTransparentIcon" :class="style.transparentIcon" />

    <slot>
      <span v-if="text">
        {{ text }}
      </span>
    </slot>
  </button>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "./TabBase.module.scss";
import IconBase from "@/elements/UI/icon/IconBase.vue";

export default defineComponent({
  name: "TabBase",
  inheritAttrs: false,
  components: {IconBase},
  props: {
    text: {
      type: String,
      default: ""
    },
    size: {
      type: String as PropType<Size>,
      default: "M"
    },
    icon: {
      type: String,
      default: ""
    },
    iconTone: {
      type: String as PropType<IconTone>,
      default: "accent"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String as PropType<ButtonTypeClick>,
      default: "button"
    }
  },
  data() {
    return {
      style
    };
  },
  computed: {
    hasDefaultSlot(): boolean {
      return Boolean(this.$slots.default);
    },

    hasVisibleIcon(): boolean {
      return Boolean(this.icon && this.icon !== "transparent");
    },

    hasTransparentIcon(): boolean {
      return this.icon === "transparent";
    },

    isOnlyIconTab(): boolean {
      return Boolean(this.hasVisibleIcon && !this.text && !this.hasDefaultSlot);
    },

    tabClasses(): string[] {
      return [
        this.style.tabBase,
        this.style[`size${this.size}`],
        this.isOnlyIconTab ? this.style.onlyIcon : ""
      ];
    }
  }
});
</script>
